export enum ETeachersQueryKeys {
  getTeachers = "getTeachers",
  getLanguages = "getLanguages",
  getTeachersByLanguage = "getTeachersByLanguage",
  getTeacherById = "getTeacherById",
  getArchivedTeachers = "getArchivedTeachers",
  restoreTeacher = "restoreTeacher",
}

export const TEACHERS_ENDPOINTS = {
  GET_ALL_TEACHERS: "/teachers",
  GET_LANGUAGES: "/languages",
  GET_ARCHIVED_TEACHERS: "/teachers/archived",
  RESTORE_TEACHER: (id: number) => `/teachers/${id}/restore`,
};
